import projectsElements from "../../styles/components/projectsElements.module.scss";
import cliksync from "../../images/projects/cliksync.png";
import {Col, Row} from "react-bootstrap";
import react from "../../images/technologies/react.png";
import {paths} from "../../storage/paths";
import {NavLink} from "react-router-dom";
import redux from "../../images/technologies/redux.png";
import nodejs from "../../images/technologies/nodejs.png";
import StatusDevelopmentButton from "../buttons/StatusDevelopmentButton";

function ClikSync() {
    return(
        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6} className={projectsElements.project}>
            <NavLink to={paths.ClikSync} className={projectsElements.link}>
                <img src={cliksync} className={projectsElements.projects_images} alt={"ClikSync Main Image"}/>
                <h6>ClikSync</h6>
            </NavLink>

            <Row>
                <Col xl={6} lg={6} md={6} sm={6} xs={12}>
                    <StatusDevelopmentButton/>
                </Col>
                <Col xl={6} lg={6} md={6} sm={6} xs={12}>
                    <img src={nodejs} className={projectsElements.projects_icons}/>
                    <img src={react} className={projectsElements.projects_icons}/>
                    <img src={redux} className={projectsElements.projects_icons}/>
                </Col>
            </Row>
        </Col>
    );
}

export default ClikSync;